import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    style: {"cursor":"pointer"},
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.helper.copy(_ctx.$el, _ctx.value, _ctx.id)), ["prevent"]))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["subtext copied-text-absolute", {show: _ctx.helper.copyHintVisible(_ctx.id)}])
    }, _toDisplayString(_ctx.helper.trans("labels.copied")), 3),
    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fa-regular fa-copy" }, null, -1))
  ]))
}